import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const NoTie = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M13.333 10.422 9.96 8.398a1.963 1.963 0 0 0 0-.797l3.374-2.024v4.845Zm-10.666 0V5.577L6.04 7.6a1.956 1.956 0 0 0 0 .797l-3.374 2.024Zm11.485-6.29a1.02 1.02 0 0 0-1.023.013L9.265 6.463A1.981 1.981 0 0 0 8 5.999c-.483 0-.92.179-1.265.464L2.87 4.145a1.018 1.018 0 0 0-1.023-.014 1.02 1.02 0 0 0-.515.885v5.967a1.019 1.019 0 0 0 1.015 1.015c.181 0 .362-.047.523-.144l3.864-2.317A1.98 1.98 0 0 0 8 9.999c.483 0 .92-.178 1.265-.463l3.864 2.318a1.01 1.01 0 0 0 1.023.013 1.02 1.02 0 0 0 .515-.884V5.016a1.02 1.02 0 0 0-.515-.885Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default NoTie;
